<template>
  <v-card  elevation="0">
    <!-- <v-card elevation="2" class="my-4 mx-4"> -->
      <v-card-text>
        <v-row>
        <v-col>
          <!-- <div>
            <p class="text-h6 grey--text">DOCUMENTOS DEL TOCA</p>
          </div> -->
          <v-toolbar v-if="roleUser == 'secacu'" color="#1D2E4B" dark dense>
            <v-toolbar-title class="text-uppercase">Documentos del Toca
              <b v-if="apelacion">
                {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
                <span v-if="apelacion.toca.complemento">-{{ apelacion.toca.complemento }}</span>
                ({{ apelacion.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Juicio Tradicional' }})
              </b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              small
              class="white--text mt-1"
              color="#607D8B"
              @click="$router.push({ name:'Comunicados' })"
            >COMUNICADOS
            </v-btn>
          </v-toolbar>
          <v-list>
            <div
              class="mb-n2"
              v-for="(doc, i) in listDocumentos"
              :key="'doc_'+i"
            >
              <v-divider></v-divider>
              <!-- DOCUMENTOS -->
              <v-row class="mt-1 mb-2 font-weight-bold align-center" justify="center">
                <v-col cols="12" sm="3">
                  <!-- {{ doc.tipo_documento.nombre }}<br> -->
                  <!-- <b>Categoría: </b><span class="font-weight-regular">{{doc.tipo_documento.categoria.nombre}} </span><br> -->
                  <!-- <b>Leyenda: </b> -->
                  <span v-if="doc.leyenda" class="font-weight-regular"><b>{{doc.leyenda.toUpperCase()}} </b></span>
                  <span v-else class="font-weight-regular"><b>{{ doc.tipo_documento.nombre.toUpperCase() }}</b></span><br>
                  <span :style="{ color: 'blue' }" v-if="doc.envio.length > 0 && doc.envio[0].vista_juez == 1">ENVIADO A JUZGADO</span>
                  <span :style="{ color: 'red' }" v-if="doc.envio.length > 0 && doc.envio[0].vista_juez == 2">PENDIENTE DE ENVIAR A JUZGADO</span>

                </v-col>
                <v-col cols="12" sm="2">
                  <!-- <b>Extracto: </b><br> -->
                  <div style="text-align: justify">
                    <!-- <b>Extracto: </b> -->
                    <span v-if="doc.extracto" class="font-weight-regular">{{doc.extracto}} </span>
                    <!-- <span v-else class="font-weight-regular"> Sin extracto </span> -->
                  </div>
                </v-col>
                <v-col cols="12" sm="2">
                  <b>Nombre: </b><span class="font-weight-regular">{{ doc.nombre_original }}</span><br>
                  <b>Tamaño: </b>
                  <span class="font-weight-regular" v-if="doc.url">
                    {{ doc.size | megas }} MB
                  </span>
                  <span class="font-weight-regular" v-if="doc.url_original">
                    {{ doc.size_original | megas }} MB
                  </span><br>
                  Creado el día:  {{ doc.created_at | formatDate }}
                </v-col>
                <v-col cols="12" sm="2">
                  <span v-if="!doc.url_evidencia && doc.url_original">
                    <v-icon color="#607D8B" >
                      mdi-file-document-edit-outline
                    </v-icon>
                    <span><b>&nbsp;En proceso de firmas</b></span><br>
                    <span>
                      <b>({{ doc.multifirmas.count_firmas }} /
                      {{ doc.multifirmas.total_firmas }})</b>
                    </span>
                    <span class="font-weight-regular"
                      v-if="doc.multifirmas.count_firmas == doc.multifirmas.total_firmas"
                    >&nbsp;Pendiente de generar evidencia criptográfica
                    </span>
                  </span>
                  <span v-if="doc.url_evidencia && doc.url_original">
                     <v-icon color="green" >
                       mdi-check-circle
                     </v-icon>
                     <span><b>&nbsp;Evidencia Generada</b></span>
                   </span>
                </v-col>
                <v-col cols="12" sm="3">
                  <span>Opciones del Documento</span><br>
                 <!-- <v-btn
                    v-if="doc.url_evidencia"
                    x-small
                    class="white--text mr-2"
                    color="#607D8B"
                    @click="getFile(doc, 'url_evidencia')"
                  >VER EVIDENCIA&nbsp; <v-icon x-small>mdi-folder</v-icon>
                  </v-btn>-->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">

                    <v-img v-if="doc.url_evidencia"
                           :src="path_logo_pdf"
                           @click="getFile(doc, 'url_evidencia')"
                           v-on="on"
                           style="max-height: 33px; max-width: 33px; cursor: pointer"/>

                    </template>
                    <span>Ver documento con firma electrónica </span>

                  </v-tooltip>

                  <!--<v-btn
                    v-if="!doc.url_evidencia && doc.url_original"
                    x-small
                    color="#607D8B"
                    class=" white--text mr-2"
                    @click="getFile(doc, 'original')">
                    VER DOCUMENTO&nbsp; <v-icon x-small>mdi-folder</v-icon>
                  </v-btn>-->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                    <v-icon  v-if="!doc.url_evidencia && doc.url_original"
                            @click="getFile(doc, 'original')"
                            large
                            color="#80CBC4"
                             v-on="on"
                    >
                      mdi-file-document-outline
                    </v-icon>
                    </template>
                    <span>Ver Documento Original</span>
                  </v-tooltip>


                  <!--<v-btn
                    v-if="!doc.url_evidencia && roleUser != 'relator'"
                    x-small
                    class="white--text mr-2"
                    color="#607D8B"
                    @click="showFirmantes(doc)"
                  >
                    VER FIRMANTES&nbsp; <v-icon x-small>
                      mdi-file-document-edit
                    </v-icon>
                  </v-btn>-->

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                                v-if="!doc.url_evidencia"
                                @click="showFirmantes(doc)"
                               large
                               color="#80CBC4"
                               v-on="on"
                                class="ml-3"
                      >
                        mdi-account-key
                      </v-icon>
                    </template>
                    <span>Ver Firmantes</span>
                  </v-tooltip>

                  <!--<v-btn v-if="(currentUser.presidente == 1 || roleUser == 'superadmin') && !doc.url_evidencia && doc.url_original"
                    color="red lighten-1" class="white--text" @click="eliminar(doc, 'doc_multifirma')" x-small>
                    Eliminar Multifirma<v-icon x-small>mdi-close</v-icon>
                  </v-btn>-->

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="(currentUser.presidente == 1 || roleUser == 'superadmin') && !doc.url_evidencia && doc.url_original && doc.envio.length === 0"
                        @click="eliminar(doc, 'resolucion')"
                        large
                        color="#BD0100"
                        v-on="on"
                        class="ml-3"
                      >
                        mdi-delete-forever
                      </v-icon>
                    </template>
                    <span>Eliminar Documento</span>
                  </v-tooltip>
                  <!-- ELIMINAR DOCUMENTO SOLO SI IMPERSONATED==TRUE (SUPERADMIN)-->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="currentUser.impersonated == true &&
                              !doc.url_evidencia &&
                              doc.multifirmas.length"
                        @click="eliminar(doc, 'doc_multifirma')"
                        large
                        color="blue"
                        v-on="on"
                        class="ml-3"
                      >
                        mdi-delete-forever
                      </v-icon>
                    </template>
                    <span>Eliminar Documento</span>
                  </v-tooltip>
                  <!-- END ELIMINAR DOCUMENTO SOLO SI IMPERSONATED=TRUE (SUPERADMIN)-->
                  <!-- ELIMINAR DOCUMENTOS ENVIOS -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-if="currentUser.impersonated == true && doc.envio.length > 0 && doc.envio[0].vista_juez == 2"
                        @click="eliminar(doc, 'doc_envio')"
                        large
                        color="red"
                        v-on="on"
                        :class="[!doc.url_evidencia ? 'ml-3' : '']"
                      >
                        mdi-delete-forever-outline
                      </v-icon>
                    </template>
                    <span>Eliminar Documento del comunicado</span>
                  </v-tooltip>
                  <!-- END ELIMINAR DOCUMENTOS ENVIOS -->
                </v-col>
              </v-row>
            </div>
            <v-divider></v-divider>
            <h2 v-if="listDocumentos.length == 0"
              class="font-weight-bold mt-3"
              style="color: grey;
              font-size: 15px;"
              align="center">
                No hay Documentos Registrados
            </h2>
          </v-list>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- <hr> -->
    <br>
    <!-- <v-row
      v-if="apelacion && apelacion.status<=44 && (currentUser.id === cuenta.relator_id || currentUser.id === cuenta.magistrado_id || roleUser == 'secacu' || roleUser == 'superadmin')" -->
    <v-row
      v-if="apelacion &&
            (roleUser == 'secacu' || roleUser == 'superadmin')"
      align="center"
      justify="space-around"
    >
      <v-btn
        dark
        class="mb-3"
        small
        dense
        color="#1D2E4B"
        @click="dialog = true"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        AGREGAR DOCUMENTO
      </v-btn>
    </v-row>
    <!-- </v-card> -->

    <!-- DIALOG AGREGAR DOCUMENTO -->
    <v-dialog
      v-model="dialog"
      max-width="900px"
      persistent
    >
      <!-- <v-row max-width="600px" justify="center"> -->
      <v-card elevation="0">
        <v-toolbar
          color="#286090"
          dark
          class="text-uppercase"
        >
          <img src="@/assets/logo_nuevo.png"style="width:50px;height:51px" class="mr-4">
          <h2>Agregar documento al Toca
            <b>
              {{ apelacion.toca.numero }}/{{ apelacion.toca.anio }}
              <span class="ml-n1" v-if="apelacion.toca.complemento" >
                -{{ apelacion.toca.complemento }}
              </span>
              ({{ apelacion.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})
            </b>
          </h2>
        </v-toolbar>

        <v-container grid-list-md>
          <v-card-text>
            <v-form @submit.prevent="save" ref="form" v-model="valid" lazy-validation>

            <!-- Multifirma -->

              <v-row>
                <v-col cols="12" md="6" align="center">
                  <!-- <v-select
                    :disabled="roleUser == 'relator'" -->
                  <v-select
                    :items="listCategorias"
                    v-model="categoria"
                    return-object
                    @change="getTipoDocumento()"
                    label="Seleccione categoría de documento"
                    prepend-inner-icon="mdi-file-outline"
                    item-value="id"
                    item-text="nombre"
                    outlined
                    dense
                    :rules="[v => !!v|| 'Seleccione categoría de documento']"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    :disabled="!categoria"
                    :items="listTipo"
                    return-object
                    :loading="listTipo.length==0 && categoria !='' "
                    v-model="tipo_documento"
                    label="Seleccione tipo de documento"
                    prepend-inner-icon="mdi-file-outline"
                    item-value="id"
                    item-text="nombre"
                    clearable
                    outlined
                    dense
                    :rules="[v => !!v|| 'Seleccione el tipo de documento']"
                    >
                  </v-select>
                </v-col>
              </v-row>

              <v-row v-if="categoria && tipo_documento.nombre == 'Otro'" class="mt-n7">
                <v-col cols="12">
                  <v-textarea
                    v-model="leyenda"
                    outlined
                    label="Especifique (leyenda)"
                    prepend-inner-icon="mdi-file-document-outline"
                    rows="1"
                    row-height="10"
                    counter="100"
                    maxlength="100"
                    hint="Máximo 100 caracteres"
                    :rules=" [v => !!v || 'Campo requerido',
                              v => v.length <= 100 || 'Requiere 100 caracteres']"
                  ></v-textarea>
                </v-col>
              </v-row>

              <v-row class="mt-n7">
                <v-col cols="12">
                  <v-textarea
                    v-model="extracto"
                    outlined
                    label="Extracto"
                    prepend-inner-icon="mdi-file-document-outline"
                    rows="3"
                    row-height="20"
                    counter="200"
                    maxlength="200"
                    hint="Máximo 200 caracteres"
                    :rules=" [v => v.length <= 200 || 'Requiere 200 caracteres']"
                  ></v-textarea>
                </v-col>
              </v-row>

              <!-- <v-row v-if="roleUser != 'relator'" class="mt-n3"> -->
              <v-row class="mt-n7">
                <v-col cols="12" md="12" align="center">
                  <v-file-input
                    v-model="file"
                    label="Seleccione archivo a firmar"
                    show-size
                    accept="application/pdf"
                    truncate-length="50"
                    :rules="fileRules"
                    @change="SelccionarArchivo($event)"
                    :disabled="archivo.encode != ''"
                  ></v-file-input>
                </v-col>
              </v-row>

              <!-- <v-container fluid v-if="roleUser == 'secacu'"> -->
              <v-container fluid>
                <h2 style="color: #B08836" class="font-weight-bold"> Seleccione una opción</h2><br>
                <hr>
                <v-radio-group
                  v-model="sign"
                  column
                  :rules="[v => !!v|| 'Seleccione una opción']"
                >
                  <v-radio
                    label="El documento requiere únicamente de mi firma electrónica"
                    value="1"
                  ></v-radio>
                  <v-radio
                    label="El documento requiere de dos o más firmas"
                    value="2"
                  ></v-radio>
                </v-radio-group>
              </v-container>

              <v-container v-if="sign == '1'" fluid class="mt-n5">
                <!-- FIRMAR DOCUMENTO  -->
                  <h2 style="color: #B08836" class="font-weight-bold"> Firmar documento</h2><br>
                  <v-row class="">
                    <v-col md="8" align="">
                      <v-file-input
                        v-model="file_firel"
                        color="blue darken-2"
                        label="Seleccionar la firel"
                        prepend-icon="mdi-certificate"
                        outlined
                        dense
                        show-size
                        accept=".pfx"
                        @change="SeleccionarPfx($event)"
                        truncate-length="50"
                        :disabled="archivo.encode != ''"
                      ></v-file-input>
                    </v-col>
                  </v-row>

                  <v-row class="mt-n6">
                    <v-col cols="8">
                      <v-text-field outlined dense
                        v-model="password"
                        label="Contraseña"
                        type="text"
                        prepend-icon="mdi-lock-outline"
                        :type="showpass ? 'text' : 'password'"
                        :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showpass = !showpass"
                        truncate-length="50"
                        :disabled="archivo.encode != ''"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="mt-n6 ml-5">
                    <v-col cols="2">
                      <v-btn
                        class="white--text"
                        :loading="loadingFirma"
                        v-model="activarBoton"
                        @click="firmar()"
                        :disabled="!pfx_selected ||
                                   !password ||
                                   (file && file.size > 20971520)"
                        color="#1D2E4B">FIRMAR FIREL
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                  <v-col v-if="archivo.file_name" class="ml-6">
                    <ul>
                      <li>
                        <h3><b>Documento Firmado:</b>
                          {{ archivo.file_name }}
                          <v-icon
                            color="green"
                        >mdi-check</v-icon>&nbsp;
                        <!-- <v-img @click="showEvidencia()"  :src="path_logo_pdf" style="max-height: 33px; max-width: 33px; cursor: pointer"/> -->
                          <v-btn
                          x-small
                          @click="saveTextAsFile()"
                          color="primary">Ver Evidencia
                          </v-btn>&nbsp;
                        </h3>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-container>

              <!--CREAR MULTIFIRMA -->
              <v-container v-if="sign == '2'" fluid class="mt-n5">
                <h2 style="color: #B08836" class="font-weight-bold"> Seleccione firmantes del documento</h2><br>
                <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-model="magistrado"
                    :items="listMagistrados"
                    outlined
                    dense
                    @change="addMagistrado()"
                    item-text="nombre"
                    item-value="id"
                    return-object
                    label="Seleccione Firmante"
                    prepend-icon="mdi-account"
                    persistent-hint
                    no-data-text="No se encontraron usuarios"
                    required
                  >
                  <template slot="selection" slot-scope="data">
                    <div v-if="data.item.segundo_apellido"class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                    </div>
                    <div v-else class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido}}
                    </div>
                  </template>
                  <template slot="item" slot-scope="data">
                    <div v-if="data.item.segundo_apellido"class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido +' '+data.item.segundo_apellido}}
                    </div>
                    <div v-else class="select-text">
                      {{ data.item.nombre +' '+data.item.primer_apellido}}
                    </div>
                  </template>
                  </v-autocomplete>
                </v-col>
                </v-row>
              </v-container>

              <v-container v-if="magistrados.length > 0">
              <v-card class="mt-n3">
                <v-card-title style="color: #B08836"  class="font-weight-bold">
                  <h4 class="heading font-weight-bold"> Firmantes del Archivo</h4>
                </v-card-title>
                <v-row class="mt-n3">
                  <v-col cols="12" md="10">
                    <ul>
                      <li
                        v-for="(magistrado,index) in magistrados"
                        v-bind:key="magistrado.nombre"
                        v-on:remove="magistrados.splice(index, 1)"
                      >
                        <h2 v-if="magistrado.segundo_apellido">
                          {{magistrado.nombre+' '+magistrado.primer_apellido+' '+magistrado.segundo_apellido}}
                          <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                        </h2>
                        <h2 v-else>
                          {{magistrado.nombre+' '+magistrado.primer_apellido}}
                          <v-btn x-small color="red darken-3" dark @click="removeMagistrado(index)">X</v-btn>
                        </h2>
                        <b v-if="magistrado.firmado == 1" style="color: green">Ya ha Firmado</b><br>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
            <!--FIN MULTIFIRMA -->
            <!-- <br> -->
                <v-divider></v-divider>
                <v-card-actions class="mb-3">
                  <v-spacer></v-spacer>
                  <v-btn
                    class="mb-3 mt-2"
                    color="grey darken-1"
                    text
                    :loading="loading"
                    @click.native="close">Cancelar
                  </v-btn>
                  <v-btn
                    class="mb-3 mt-2"
                    color="#607D8B"
                    text
                    :loading="loading"
                    :disabled="!valid"
                    @click="validate()"
                  >
                    Guardar Documento
                  </v-btn>
                </v-card-actions>
            </v-form>
          </v-card-text>
        </v-container>
      </v-card>
    <!-- </v-row> -->
    </v-dialog>
    <!-- FIN DIALOG AGREGAR DOCUMENTO -->

    <v-dialog
      v-model="progress"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="#0A4A79"
        dark
      >
        <v-card-text>
          Cargando Archivo
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="dialogFirmantes"
      v-model="dialogFirmantes"
      persistent
      max-width="900px"
    >
      <Firmantes :documento_id="documento_id" @close="closeFirmantes"/>
    </v-dialog>

  </v-card>
</template>

<script>
  import { mapMutations } from "vuex";
  const Swal = require('sweetalert2');
  import {SelectFileSign,message,resetValues,SelectPfx,OpenPfx,PKCS7creado,extFileUpload,infoCer} from '@/services/cliente';
  import { CertificateRequest } from '@/services/clasesFirma';
  import { mapGetters } from "vuex";
  import Firmantes from "@/components/Firmantes";

  export default {
    components: {
      Firmantes
    },
    props: {
      apelacion: {
        type: Object,
        required: true
      },
      cuenta: {
        type: Object,
        required: false
      },
      role: {
        type: String,
        required: true
      },
      source: String
    },
    data() {
      return {
        // apelacion: null,
        documento_id: '',
        apelacion_id:'',
        listDocumentos: [],
        magistrado:'',
        magistrados: [],
        magistrados_ids: [],
        file_firel: [],
        path_logo_pdf:require('@/assets/img/file-pdf.svg'),
        pfx_selected: false,
        pdf_selected: false,
        password:'',
        showpass: false,
        activarBoton: false,
        loadingFirma: false,
        loadingResolucion: false,
        loadingEliminar: false,
        loading: false,
        progress: false,
        dialog: false,
        dialogFirmantes: false,
        valid: true,
        files:[],
        file:[],
        url_multifirma:'',
        categoria:'',
        tipo_documento:'',
        listTipo:[],
        leyenda:'',
        extracto:'',
        archivo:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        archivoDefault:{
          encode:'',
          type:'application/pdf',
          file_name:'',
          size:''
        },
        sign:'',
        fileRules: [
          value => !value || value.size < 20971520 || 'El documento no debe exceder de 20MB',
          // v => !v || 'El Campo es Requerido',
        ],
      };
    },
    computed: {
      ...mapGetters(['currentUser', "listMagistrados", "listCategorias", "roleUser"])
    },
    filters: {
      megas: function (value) {
        if (!value) return ''
        value = value / 1048576
        return value.toFixed(2);
      },
    },
    watch: {
      categoria: function (val) {
        if(val){
          this.tipo_documento = ''
          this.leyenda = ''
        }
      },
      tipo_documento: function (val) {
        if(val){
          this.leyenda = ''
        }
      },
      sign: function (val) {
        if(val == '1'){
          this.magistrados = []
          this.magistrados_ids = []
        }
        else if (val == '2') {
          this.file_firel = []
          this.password = ''
          this.activarBoton = false
          // this.archivo = Object.assign({}, this.archivoDefault)
        }
      },
    },
    created() {
      this.getDocs();
      this.getMagistrados()
      this.getCategorias()
    },
    methods: {
      getDocs(){
        this.listDocumentos = []
        this.$store.dispatch("GET_DOCUMENTOS",  {
          url: '/apelacion/' + this.apelacion.id +'/documentos'
        }).then(response => {
          this.listDocumentos = response.data.data.documentos
          this.listDocumentos.forEach(documento => {
            if (documento.multifirmas.length) {
              documento.multifirmas.total_firmas = documento.multifirmas.length
              documento.multifirmas.count_firmas = 0
              documento.multifirmas.forEach(firma => {
                if (firma.firmado == 1) {
                  documento.multifirmas.count_firmas ++
                }
              });
            }

          });
          //05 de Marzo se pueden observar todos los documentos para todos
          /*if (this.roleUser == 'relator' || this.roleUser == 'magistrado') {
            var listDocumentos = response.data.data.documentos
            // console.log(listDocumentos);
            listDocumentos.forEach(documento => {
              if(documento.categoria_id == 3){
                this.listDocumentos.push(documento)
              }
            });
          } else {
            this.listDocumentos = response.data.data.documentos
          }*/

        }).catch(err => {
          console.log(err);
        });
      },
      getMagistrados(){
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" })
          .then(response => {
            // console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      },
      showFirmantes(item){
        this.documento_id = item.id
        this.dialogFirmantes = true
        // localStorage.setItem("currentDocument", JSON.stringify( item.id ));
        // this.$router.push({ name:'DocumentoFirma' })
      },
      getCategorias(){
        this.$store.dispatch("GET_CATEGORIAS",  { url: "/categorias" })
          .then(response => {
            // console.log(this.listCategorias);
        })
        .catch(error => {
          console.log(error);
        });
      },
      getTipoDocumento(){
        this.listTipo = []
        this.$store.dispatch("GET_TIPO_DOCUMENTO",  { url: "/tipos-documentos",
        params: {
          categoria_id:this.categoria.id
        }
        }).then(response => {
          this.listTipo = response.data.data.tipos_documentos
        }).catch(error => {
          console.log(error);
        });
      },
      fileSelected(){
        var file = this.file;
        this.getBase64(file).then(data => {
          this.files.push(data);
        });
      },
      getBase64(file) {
        return new Promise((resolve, reject) => {
          if (file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
          }
        });
      },
      FilesToUpload() {
        if (this.files.length) {
          this.files.forEach(file => {
            var block = file.split(";");
            // Get the content type of the image
            var contentType = block[0].split(":")[1]; // In this case "jpg
            // get the real base64 content of the file
            this.archivo['type'] = contentType
            var realData = block[1].split(",")[1];
            //console.log(realData);
            this.archivo['encode'] = realData
            this.archivo['size'] = this.file.size
            this.archivo['file_name'] = this.file.name.split(".pdf")[0];
          });
        }
      },
      addMagistrado() {
        if (this.magistrado=="") {
          Swal.fire({
            icon: 'warning',
            title: 'No se ha seleccionado Magistrado',
            showConfirmButton: false,
            timer: 1500
          })
        } else if (this.magistrados_ids.includes(this.magistrado.id)) {
          Swal.fire({
            icon: 'warning',
            title: this.magistrado.nombre + ' ya ha sido agregado',
            showConfirmButton: false,
            timer: 1500
          })
          this.magistrado = ''
        } else {
          this.magistrados.push(this.magistrado)
          this.magistrados_ids.push(this.magistrado.id)
          this.magistrado = ''
        }
      },
      removeMagistrado(index) {
        this.magistrados.splice(index, 1)
        this.magistrados_ids.splice(index, 1)
      },
      validate() {
        // console.log(this.file);
        if (this.$refs.form.validate()) {
          if ((this.file == "" || this.file == null) && (this.roleUser != 'relator')) {
            Swal.fire({
              icon: 'warning',
              title: 'Selecciona un Documento',
              confirmButtonText: "Aceptar",
            })
            this.loading = false
          }
          else if(this.magistrados_ids.length == 0 && this.sign == "2"){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Agregar Firmantes',
              confirmButtonText: "Aceptar",
            })
          }
          else if(!this.archivo.encode && this.sign == "1"){
            Swal.fire({
              icon: 'warning',
              title: 'Favor de Firmar Documento',
              confirmButtonText: "Aceptar",
            })
          }
          else {
            this.loading = true
            if (this.sign == "1") {
              this.url_multifirma = "/documento/"+ this.apelacion.id +"/firma"// pendiente
              this.saveFirma() // pendiente
            } else if (this.sign == "2") {
              this.url_multifirma = "/documento/"+ this.apelacion.id +"/multifirma"
              this.saveMultifirma()
            }
          }
        }
        else {
          Swal.fire({
            icon: 'error',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        }
      },
      saveFirma() {
        // this.FilesToUpload()
        const data = {
          // magistrados: this.magistrados_ids,
          file: this.archivo,
          categoria_id: this.categoria.id,
          tipo_documento_id: this.tipo_documento.id,
          leyenda: this.leyenda,
          extracto: this.extracto
        }
        // console.log(data);
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Documento guardado con éxito',
            timer: 1500,
          })
          this.loading = false
          this.getDocs()
          this.close();
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      saveMultifirma() {
        this.FilesToUpload()
        const data = {
          magistrados: this.magistrados_ids,
          file: this.archivo,
          categoria_id: this.categoria.id,
          tipo_documento_id: this.tipo_documento.id,
          leyenda: this.leyenda,
          extracto: this.extracto
          // apelacion_id: this.currentApelacion.id
        }
        this.$store.dispatch("CREATE_MULTIFIRMA",  { url: this.url_multifirma, data: data })
        // this.$store.dispatch("CREATE_MULTIFIRMA",  { url: "/previo-admision/"+ 4, data: data })
        .then(response => {
          Swal.fire({
            icon: 'success',
            title: 'Documento y Firmantes Registrados con Éxito',
            timer: 1500,
          })
          this.loading = false
          this.getDocs()
          this.close();
        })
          .catch(error => {
            this.loading = false
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: error.response.data.message,
              confirmButtonText: "Aceptar"
            });
            // this.close();
          });
      },
      eliminar(doc, tipo_doc){
        var title = '¿Confirma eliminar el proceso de multifirma?'
        if (tipo_doc == 'doc_envio') {
          title = '¿Confirma eliminar el documento del comunicado?'
        }
        Swal.fire({
          title: title,
          text: "Esta acción no se puede deshacer",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Si, eliminar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
        if (result.isConfirmed) {
          if (tipo_doc=='resolucion') {
            var url = "/multifirma/"+doc.id
          }
          if (tipo_doc=='doc_multifirma') {
            var url = "/multifirma-documento/"+doc.id
          }
          if (tipo_doc=='doc_envio') {
            var url = "/envio-documento/" + doc.id + '/delete'
          }
          this.loadingEliminar = true
          this.$store.dispatch("DELETE_DOCUMENTO",{ url: url }).then((response) => {
            //console.log(response.data);
            this.loadingEliminar = false
            if (response.data.status=='ok') {
            Swal.fire({
              icon: 'success',
              title: 'Se eliminó correctamente',
              confirmButtonText: "Aceptar",
            })
            this.$emit('updateCuenta')
          }
            this.getDocs()
            //this.$router.go(this.$router.currentRoute)
            }).catch(err => {
              console.log(err);
            });
          }
        })
      },
      //PARA VALIDAR QUE EL NOMBRE DEL ARCHIVO NO CONTENGA "." NI CARARACTERES ESPECIALES PARA EVITAR ERROR EN LA GENERACION DE LA EVIDENCIA
      containsSpecialChars(str) {
        const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
      },
      validaNombreDeArchivo(file) {
        let filename = file.name
        let onlyname_without_extension = filename.substring(0, filename.lastIndexOf('.'));
        let result = this.containsSpecialChars(onlyname_without_extension);
        if(result){
          Swal.fire({
            icon: 'warning',
            title: 'El nombre del documento NO debe contener "puntos" ni caracteres especiales como . ! @ # $ % ^ & * ( ) + ~',
            confirmButtonText: "Aceptar",
          })
          return false;
        }
        return true
      },
      //Metodos Firel
      SelccionarArchivo(file) {
        if (this.file && this.file.name) {
          let is_valid_name_oficio_apelacion = this.validaNombreDeArchivo(file);
          if(! is_valid_name_oficio_apelacion){
            this.file= []
            return false;
          }
          SelectFileSign(file).then((isValidFile)=>{
              if(isValidFile){
                  this.message=message;
                  this.pdf_selected = true
                  this.extArchivoCargado=extFileUpload;
              }
           });
          this.files = []
          this.fileSelected()
        } else {
          this.files = []
        }
      },
      SeleccionarPfx(filePFX) {
        if (filePFX) {
          this.activarBoton=SelectPfx(filePFX);
          if(this.activarBoton){
              this.filePFXselct=filePFX;
              this.pfx_selected = true
          }
        }
      },
      firmar() {
        if (!this.$refs.form.validate()) {
          Swal.fire({
              icon: 'warning',
              title: 'Selecciona un Documento',
              confirmButtonText: "Aceptar",
            })
          return false;
        }
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
              if (!infoCer.VigenciaValida) {
                    Swal.fire({
                      icon: 'warning',
                      title: 'La vigencia de su Firel no es válida',
                      confirmButtonText: "Aceptar",
                    })
                    return false
                  }
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña inválida, Favor de Verificar',
                confirmButtonText: "Aceptar",
              })
            }
         });
      },
      creaEvidencia(pkcs7)
      {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        this.loadingFirma = true;
        this.loadingeFirma = true;
        // let archivos = this.pkcs7.nativeElement.files;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest })
           .then(response => {
             Swal.close();
             // console.log(response.data);
             this.loadingFirma = false;
             this.loadingeFirma = false;
             Swal.fire({
               icon: 'success',
               title: 'Documento Firmado con Éxito',
               confirmButtonText: "Aceptar",
               timer: 1500,
             })
             this.archivo.encode = response.data.data.resultados.PdfBase64;
             this.archivo.size = this.file.size;
             var fecha = new Date();
             this.archivo.file_name = "evidencia_" + fecha.valueOf();
            //  this.sign = '';
             this.file_firel = [];
            //  this.file = [];
             this.password = '';
             this.activarBoton = false;
            //  this.$refs.evidencia.resetValidation()
           })
           .catch(err => {
             console.log(err);
             this.loadingFirma = false;
           });
        } else {
          this.creaevidencia=false;
        }
      },
      saveTextAsFile() {
        var fileB64 = this.archivo.encode
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('target' ,'_blank');
        // link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },
      getFile(item, campo){
        var url = "/documento/"+ item.id +"/file"
        if (campo == 'original') {
          url = '/documento/'+ item.id + '/previo-multifirma'
        }
        var data = {
          campo: campo
        }
        this.progress = true
        this.$store.dispatch("GET_FILE", { url: url, data: data  }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target' ,'_blank');
          document.body.appendChild(link);
          link.click();
          this.progress = false
        }).catch(err => {
          console.log(err);
          this.progress = false
        });
      },
      closeFirmantes (val) {
        // console.log('val', val);
        // if (val === 'reloadPage') {
        //   this.getDocs()
        // }
        // this.$refs.form.resetValidation()
        this.getDocs()
        this.dialogFirmantes = false
        // this.documento_id = ''
        // this.data = Object.assign({}, this.defaultData)
      },
      close () {
        this.dialog = false
        this.resetValidation()
        // this.$refs.form.reset()
        this.archivo = Object.assign({}, this.archivoDefault)
        this.files = []
        this.file = []
        this.file.value = null
        this.categoria = ''
        this.tipo_documento = ''
        this.leyenda = ''
        this.extracto = ''
        this.sign = ''
        this.magistrado = ''
        this.magistrados = []
        this.magistrados_ids = []
        resetValues()
        this.file_firel = []
        this.password = ''
        this.activarBoton = false
        // this.$emit('close', false);
        this.pfx_selected = false
        this.pdf_selected = false
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    }
  };
</script>
